export default "__VITE_ASSET__HttEggsLG_LVzojYu_xHDQ__"